module.exports = __webpack_public_path__ + "static/3-844cda2aebe5ce3a85b706624d196d47.jpg";